import type { Product, ProductOptionalComponent, ProductSupplyMode } from '../types';
import { normalizeAvailabilityMode } from './productAvailability';
import { isTransportKind } from './transportCapacity';

function normalizeSupplyMode(value: string | null | undefined): ProductSupplyMode | null {
  if (value === 'owned_inventory' || value === 'external_subrental' || value === 'service') {
    return value;
  }
  return null;
}

function finiteNonNegInt(value: unknown, fallback: number): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n) || n < 0) return fallback;
  return Math.floor(n);
}

/** Mappa Supabase products-rad till admin Product-typ. */
export function mapDbProductRow(row: Record<string, unknown>): Product {
  const rawKind = row.transport_kind;
  return {
    id: String(row.id),
    name: String(row.name ?? ''),
    category: String(row.category ?? ''),
    pricePerDay: Number(row.price_per_day ?? 0),
    description: String(row.description ?? ''),
    shortDescription: String(row.short_description ?? ''),
    image: String(row.image ?? ''),
    gallery: (row.gallery as string[]) || [],
    popular: Boolean(row.popular),
    featured: Boolean(row.featured),
    includes: (row.includes as string[]) || [],
    upgrades: (row.upgrades as Product['upgrades']) || [],
    optionalComponents: (row.optional_components as ProductOptionalComponent[]) || [],
    setupTime: row.setup_time as string | undefined,
    size: row.size as string | undefined,
    transportKind: isTransportKind(rawKind) ? rawKind : null,
    transportUnits: finiteNonNegInt(row.transport_units, 1) || 1,
    transportTops: finiteNonNegInt(row.transport_tops, 0),
    transportSubs: finiteNonNegInt(row.transport_subs, 0),
    transportFlightcases: finiteNonNegInt(row.transport_flightcases, 0),
    hiddenFromProducts: Boolean(row.hidden_from_products),
    slug: row.slug as string | undefined,
    videos: (row.videos as string[]) || [],
    priceOnRequest: Boolean(row.price_on_request),
    quoteFormMessage: (row.quote_form_message as string | null) ?? null,
    newUntil: (row.new_until as string | null) ?? null,
    rentalQuantity: row.quantity != null ? Number(row.quantity) : null,
    availabilityMode: normalizeAvailabilityMode(row.availability_mode as string | null),
    supplyMode: normalizeSupplyMode(row.supply_mode as string | null),
  };
}
